// extracted by mini-css-extract-plugin
module.exports =  {"ChatUserOverview":"y8AW6V0SKPXn8LY4Ixmg"};